<template>
	<AuthLayout>
		<template #eyebrow>Password recovery</template>
		<template #headline>Set a new<br/><span class="accent">password.</span></template>
		<template #lead>Create a new secure password for your account.</template>

		<div class="auth-card__head">
			<p class="auth-card__step">New password</p>
			<h1 class="auth-card__title">Enter new password</h1>
			<p class="auth-card__subtitle">Choose a strong password with at least {{ getMinPasswordLength }} characters</p>
		</div>

		<form class="auth-form" @submit.prevent="changePasswordRequest">
			<div class="auth-field">
				<label class="auth-field__label" for="new-password">New Password</label>
				<div class="auth-input-wrap">
					<input
						id="new-password"
						v-model="password"
						:type="showPassword ? 'text' : 'password'"
						class="auth-input-light auth-input-light--with-icon"
						:placeholder="`Min ${getMinPasswordLength} characters`"
					/>
					<button type="button" class="auth-input__icon-btn" @click="togglePassword">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>
						</svg>
					</button>
				</div>
				<p v-if="notValidPassword && password.length > 0" class="auth-field-error">
					{{ $t('reset_password.password_min_length', { length: getMinPasswordLength }) || `Password must be at least ${getMinPasswordLength} characters` }}
				</p>
			</div>

			<div class="auth-field">
				<label class="auth-field__label" for="confirm-password">Confirm Password</label>
				<input
					id="confirm-password"
					v-model="passwordConfirmation"
					type="password"
					class="auth-input-light"
					placeholder="Repeat password"
				/>
				<p v-if="passwordNotTheSame && passwordConfirmation.length > 0" class="auth-field-error">
					{{ $t('reset_password.passwords_mismatch') || 'Passwords do not match' }}
				</p>
			</div>

			<div v-if="error" class="auth-error">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
				{{ error }}
			</div>

			<button type="submit" class="auth-btn" :disabled="notValidPassword || passwordNotTheSame">
				Set New Password
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
			</button>
		</form>

		<div class="auth-card__foot">
			<p><router-link :to="{ name: 'v2-login' }">&larr; Back to Sign In</router-link></p>
		</div>
	</AuthLayout>
</template>


<script>
import ChangePassword from '@/pages/change-password.vue';
import AuthLayout from './auth-layout.vue';

export default {
	name: 'V2ChangePassword',

	extends: ChangePassword,

	components: {
		...ChangePassword.components,
		AuthLayout,
	},
};
</script>


<style lang="sass" scoped>
@import './auth-form-styles'

.auth-field-error
	margin-top: 6px
	font-size: 12px
	color: $red
</style>
